module.exports = __webpack_public_path__ + "media/audio25.7097dbf1.mp3";